import { render, staticRenderFns } from "./FolioLavado.vue?vue&type=template&id=a299fc2c&"
import script from "./FolioLavado.vue?vue&type=script&lang=js&"
export * from "./FolioLavado.vue?vue&type=script&lang=js&"
import style0 from "./FolioLavado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports